import React from 'react';
import { Link } from 'react-router-dom';
import { SessionAuth, useSessionContext } from 'supertokens-auth-react/recipe/session';
import OrderManagement from './OrderManagement';

const OrderManagementContent = () => {
  const session = useSessionContext();

  if (session.loading) return null;

  const roles = session.accessTokenPayload && session.accessTokenPayload["st-role"]?.v;
  const canManageOrders = roles && (roles.includes("admin") || roles.includes("facility_printful"));

  if (!canManageOrders) {
    return (
      <div className="container mx-auto p-4 text-center mt-10">
        <h1 className="text-2xl font-bold text-red-600">Access Denied</h1>
        <p className="text-gray-600 mt-2">Order Management is only available for admins and facility staff.</p>
        <Link to="/orders" className="text-blue-500 hover:underline mt-4 block">View your Order History</Link>
      </div>
    );
  }

  return (
    <div>
      <OrderManagement />
    </div>
  );
};

const OrderManagementPage = () => (
  <SessionAuth>
    <OrderManagementContent />
  </SessionAuth>
);

export default OrderManagementPage;
